import React from 'react';

export default function StatusBadge({ status }) {
  const base = 'inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded';
  if (status === 'succeeded') return <span className={`${base} bg-green-600 text-white`}>Succeeded</span>;
  if (status === 'failed') return <span className={`${base} bg-red-600 text-white`}>Failed</span>;
  return <span className={`${base} bg-yellow-500 text-black`}>Pending</span>;
}
